import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generateAdvisorWizard_Variable_Initial, ModuleFE_Advisor_AdvisorSnippet, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import { _keys, exists, MUSTNeverHappenException, sortArray, StaticLogger } from '@nu-art/ts-common';
import { ICONS, SearchableListPopUp } from '@app/styles';
import { Button, getElementCenterPos, LL_H_C, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { fillDefaultFormVariables } from '../../../Component_AdvisorWizard_Step/utils.js';
const snippetHasVariablesWithDefaultValues = (snippet) => {
    return snippet.formVariables?.some(formVar => formVar.isCommon && exists(formVar.defaultValueId));
};
export const AdvisorWizardTree_SnippetRenderer = (props, treeExpansionState) => {
    const snippet = ModuleFE_Advisor_AdvisorSnippet.cache.unique(props.item.id);
    if (!snippet)
        throw new MUSTNeverHappenException(`Could not find a snippet for _id ${props.item.id}`);
    const hasDefaults = snippetHasVariablesWithDefaultValues(snippet);
    return _jsxs(LL_H_C, { className: 'tree-data', children: [snippet.renderedLabel ?? snippet.label, hasDefaults && _jsxs(Button, { variant: 'text', onClick: e => {
                    stopPropagation(e);
                    fillDefaultFormVariables(props.item.editable, snippet);
                }, children: [_jsx(ICONS.advisor_v5_defaultOptions.component, {}), "Default"] }), !props.item.disabled && _jsx(AdvisorWizardTree_SnippetAddVariable, { snippet: snippet, variableData: props.item.editable, snippetExpanded: props.node.expanded, expandSnippet: () => treeExpansionState[props.node.path] = true })] });
};
const AdvisorWizardTree_SnippetAddVariable = (props) => {
    const varIds = props.snippet.formVariables?.map(formVar => formVar.id) ?? [];
    const existingVarIds = _keys(props.variableData.item ?? {});
    const varIdsToAdd = varIds.filter(id => !existingVarIds.includes(id));
    if (!varIdsToAdd.length)
        return _jsx(_Fragment, {});
    return _jsx(ICONS.advisor_avn_add.component, { onClick: (e) => {
            stopPropagation(e);
            const variables = ModuleFE_Advisor_Variable.cache.filter(variable => varIdsToAdd.includes(variable._id));
            sortArray(variables, variable => variable.name.toLowerCase());
            SearchableListPopUp.Show({
                itemList: variables,
                labelMapper: variable => variable.name,
                onItemSelected: async (variable) => {
                    const formVariable = props.snippet.formVariables?.find(formVar => formVar.id === variable._id);
                    if (!formVariable) {
                        StaticLogger.logError('Trying to add a variable to a snippet without a formVar for it in the snippet', `Snippet ID: ${props.snippet._id}`, `Variable ID: ${variable._id}`);
                        return;
                    }
                    const data = generateAdvisorWizard_Variable_Initial(variable, props.snippet);
                    props.expandSnippet();
                    props.variableData.updateObj({ [variable._id]: data });
                },
                popUpProps: {
                    originPos: getElementCenterPos(e.currentTarget),
                    modalPos: { x: -1, y: 1 },
                    offset: { x: 15, y: -15 },
                    xAxisAnchor: 'right'
                }
            });
        } });
};
//# sourceMappingURL=snippet-renderer.js.map